import React from 'react'
import PasswordResetForm from './PasswordResetForm'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useMeQuery } from '../../store/kopiliot-api/base-api'
import { toast } from 'react-toastify'
import PasswordResetRequest from './PasswordResetRequest'
import bgImg from '../../assets/img/generic/18.jpg'
import SplitPageLayout from 'pages/_layout/SplitPageLayout'

const PasswordReset = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { data: me } = useMeQuery(null)

  if (me) {
    toast('You are already logged in')
    navigate('/')
  }

  if (searchParams.get('reset_token')) {
    return (
      <SplitPageLayout bgProps={{ image: bgImg }}>
        <div className="text-center">
          <h3>Mettez à jour votre mot de passe</h3>
        </div>
        <PasswordResetForm
          token={searchParams.get('reset_token')}
          title={'Réinitialisez votre mot de passe'}
          action={'reset'}
        />
      </SplitPageLayout>
    )
  }

  return <PasswordResetRequest />
}

export default PasswordReset
